// extracted by mini-css-extract-plugin
export default {"Logo":"logo-module__Logo--iTihD"};